import type { FilingNote } from './types'

export const FilingCard = ({ filing }: { filing: FilingNote }) => (
  <div className="rounded-lg bg-neutral-100 p-3">
    <p className="text-xs text-ink-subtle">Will be filed under it</p>
    <p className="text-sm font-medium text-foreground">
      {filing.period} · {filing.pages}
    </p>
    <p className="truncate text-xs text-ink-subtle">{filing.fileName}</p>
  </div>
)
